export default "__VITE_ASSET__1b7ec165__"